export default __webpack_public_path__ + "locales/si/Translations.json?hash=5e40d3f3949b52f2fa30c5bfde67b837";